import { useRouter } from 'next/router'
import SectionIntro from '../../components/ivystore/SectionIntro'
import SectionSofaTypes from '../../components/ivystore/SectionSofaTypes'
import SectionAdvantages from '../../components/ivystore/SectionAdvantages'
import SectionFindCouch from '../../components/ivystore/SectionFindCouch'
// import SectionBrands from '../../components/ivystore/SectionBrands'
// import SectionArticles from '../../components/ivystore/SectionArticles'
// import SectionFaqs from '../../components/ivystore/SectionFaqs'
import LandingWrapper from '../../components/landing/elements/LandingWrapper'
import Seo from '../../components/blog/seo'
import { fetchSEO } from '../../lib/blog/api'
import SectionProducts from '../../components/ivystore/SectionProducts'
import baseUrl from '../../lib/base-url'
import SectionStores from '../../components/ivystore/SectionStores'
import BreadCrumbs from '../../components/ivystore/BreadCrumbs'
import populateSeoWith from '../../lib/populate-seo'
import SectionCouchRemoval from '../../components/ivystore/SectionCouchRemoval'

export const getServerSideProps = async ({ query, res }) => {
  const { stateSlug, citySlug } = query

  // Fetch state geography data
  const geographyResponse = await fetch(`${baseUrl}/api/ivy-store/geography?stateSlug=${stateSlug}`)
  const { data: stateData } = await geographyResponse.json()

  // Fetch stores for this state if it exists
  let stores = []
  if (stateData) {
    const storesResponse = await fetch(`${baseUrl}/api/ivy-store/stores?stateSlug=${stateSlug}&citySlug=${citySlug}`)
    const { data: storesData } = await storesResponse.json()
    stores = storesData
  }

  // Fetch 8 latest items for this state
  const productsResponse = await fetch(`${baseUrl}/api/ivy-store/state-items?stateSlug=${stateSlug}&citySlug=${citySlug}&count=8`)
  const { data: productsData } = await productsResponse.json()

  const seo = await fetchSEO('ivystore-state-city')
  populateSeoWith(seo, {
    state: stateData?.name,
    city: stateData?.cities.find(c => c.slug === citySlug)?.name,
    min_price_couch_in_city: productsData?.reduce((min, p) => Math.min(min, p.data.price), 500) ?? 500,
  })

  if (!stateData) {
    res.statusCode = 404
  }

  return {
    props: {
      seo,
      stateData,
      productsData,
      stores
    }
  }
}

export default function IvyStoreStateCityPage ({ seo, stateData, productsData, stores }) {
  const router = useRouter()
  const { stateSlug, citySlug } = router.query

  if (!stateData) {
    return (
      <>
        <Seo seo={seo}/>
        <LandingWrapper>
          <div className="text-center py-5">
            <h1>Region Not Found</h1>
            <p>The region {stateSlug} was not found.</p>
            {/* TODO: Add similar state suggestions here */}
          </div>
        </LandingWrapper>
      </>
    )
  }

  const cityData = stateData?.cities.find(c => c.slug === citySlug)

  return (
    <>
      <Seo seo={seo} />

      <BreadCrumbs
        stateData={stateData}
      />

      <LandingWrapper gap={'4rem'}>
        <SectionIntro
          title={`Find Your Dream Couch up to 70% less than Retail in ${cityData.name}, ${stateData.code}`}
          text={`Discover Affordable, Quality-Checked Sofas in ${cityData.name}, ${stateData.code}. Delivery in 1-3 Days.`}
        />

        <SectionProducts
          products={productsData}
          stateData={stateData}
          cityData={cityData}
        />

        <SectionStores
          stores={stores}
        />

        <SectionSofaTypes
          stateSlug={stateData.slug}
          citySlug={cityData.slug}
        />

        <SectionFindCouch
          stateData={stateData}
          cityData={cityData}
        />

        <SectionAdvantages
          stateData={stateData}
          cityData={cityData}
        />

        <SectionCouchRemoval
          stateData={stateData}
          cityData={cityData}
        />

        {/*<SectionBrands*/}
        {/*  brands={brands}*/}
        {/*  stateSlug={stateData.slug}*/}
        {/*  citySlug={cityData.slug}*/}
        {/*/>*/}
        {/*<SectionArticles articles={articles} />*/}
        {/*<SectionFaqs items={faqItems} />*/}
      </LandingWrapper>
    </>
  )
}